export default "__VITE_ASSET__CLwfANsa__"